import React from "react";
import { NavLink } from "react-router-dom";
import { useFeature } from "store/selectors/hooks";

export const MessagingTopMenuLink: React.FC = () => {
    const smsEnabled = useFeature("sms");

    if (!smsEnabled) {
        return null;
    }

    return (
        <li>
            <NavLink
                activeClassName="bg-brand-100 text-brand-800 hover:bg-brand-200 hover:text-brand-900"
                className="px-3 py-2 rounded hover:bg-gray-100 hover:text-black text-gray-800 whitespace-nowrap block"
                to="/messaging">
                Messaging
            </NavLink>
        </li>
    );
};
